import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { AdjustStartTimeFormGroup } from './adjust-start-time-form.type';
import { IParkingSessionDTO, ParkerRegistrationType } from 'src/app/base/models/models.swagger.generated';

@Component({
    selector: 'app-adjust-start-time-form',
    templateUrl: './adjust-start-time-form.component.html',
    styleUrls: ['./adjust-start-time-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DateTimePickerModule, TranslateModule]
})
export class AdjustStartTimeFormComponent implements OnInit {
  @Input() public adjustStartTimeForm: AdjustStartTimeFormGroup;
  @Input() public parkingSession: IParkingSessionDTO;

  public maxDate;

  ngOnInit() {
    this.maxDate = this.calculateMaxStartTime();
  }

  private calculateMaxStartTime(): Date {
      if (!this.parkingSession) {
        return new Date();
      }
      let date : Date;
      const fixedRegistrations = this.parkingSession.parkerRegistrations?.filter(r => r.type === ParkerRegistrationType.AutoScheduleClose || r.type === ParkerRegistrationType.ParkingRangerEntry) ?? [];
      if (fixedRegistrations.length > 0) {
        fixedRegistrations.sort((a, b) => a.registrationDateTime.diff(b.registrationDateTime).toMillis());
        date = fixedRegistrations[0].registrationDateTime?.toJSDate() ?? new Date();
      } else {
        date = this.parkingSession.lastEntryDateTime?.toJSDate() ?? new Date();
      }
      return date;
    }
}
